





















import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
@Component({})
export default class CaseSteps extends Vue {
  @Prop({ type: Array }) readonly steps!: string[]
  @Prop({ type: Number }) readonly at!: number
  @Prop({ type: Boolean }) readonly canSelect!: boolean
  @Prop({ type: Boolean }) readonly disable!: boolean
  @Prop({ type: String }) readonly width!: string

  handleClick (index: number) {
    if (this.disable) {
      return
    }
    this.onClick(index)
  }

  @Emit('click')
  onClick (index: number) {
    return index
  }
}
